//下载exc方法
export const downExcel = (res, name, that) => {
    let blob = res;
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = window.URL.createObjectURL(blob);
    link.download = `${name}.xlsx`;
    // 触发点击
    document.body.appendChild(link);
    link.click();
    // 然后移除
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
    that.$loading.close();
};

// timeType表示 所取时间格式为ymd(年月日)、hm（年月日 时分）、hms(年月日 时分秒)
// lineType表示年月日之间连接字符 eg:- / .
// hasTime 表示有后台时间格式 ,进行时间格式化转换
export const CurentTime = (timeType, lineType, hasTime) => {
        if (hasTime) {
            var now = new Date(hasTime);
        } else {
            var now = new Date();
        }

        var year = now.getFullYear(); //年
        var month = now.getMonth() + 1; //月
        var day = now.getDate(); //日

        var hh = now.getHours(); //时
        var mm = now.getMinutes(); //分
        var ss = now.getSeconds() //秒
        var clock = year + lineType;

        if (month < 10)
            clock += "0";

        clock += month + lineType;

        if (day < 10)
            clock += "0";

        clock += day + " ";
        switch (timeType) {
            case 'ymd':
                break;
            case 'hm':
                if (hh < 10)
                    clock += "0";

                clock += hh + ":";
                if (mm < 10) clock += '0';
                clock += mm;
                break;
            case 'hms':
                if (hh < 10)
                    clock += "0";

                clock += hh + ":";
                if (mm < 10) clock += '0';
                clock += mm + ":";
                if (ss < 10) clock += '0';
                clock += ss;
        }
        return (clock);
    }
    /**
     * @description 绑定事件 on(element, event, handler)
     */
export const on = (function() {
    if (document.addEventListener) {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false)
            }
        }
    } else {
        return function(element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function() {
    if (document.removeEventListener) {
        return function(element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false)
            }
        }
    } else {
        return function(element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler)
            }
        }
    }
})()

/**
 * @description 对数组进行分类 sortArrList(element, event, handler)
 */

export const sortArrList = (function(initArr, id) {
    var map = {},
        dest = [];
    for (var i = 0; i < initArr.length; i++) {
        var ai = initArr[i];
        if (!map[ai[id]]) {
            dest.push({
                id: ai[id],
                data: [ai]
            });
            map[ai[id]] = ai;
        } else {
            for (var j = 0; j < dest.length; j++) {
                var dj = dest[j];
                if (dj.id == ai[id]) {
                    dj.data.push(ai);
                    break;
                }
            }
        }
    }
    return dest
})

/**
 * @description 对数组，根据对象属性值进行排序 sortArrObject(arr, key)
 */
export const sortArrObject = (function(arr, key) {
    return arr.sort(
        //a 是第一 b 是a+1处的数据
        function(a, b) {
            var no1 = a[key];
            var no2 = b[key];
            return ((no1 < no2) ? -1 : ((no1 > no2) ? 1 : 0));
        }
    )
})

/**
 * @description 获取字典 getDictCode(code)
 */
export const getDictCode = (function(that, code) {
    return new Promise((resolve, reject) => {
        that.$api.publicQuery.pubqDict({ itemCode: code })
            .then(res => {
                resolve(res)
            })
            .catch(res => {
                that.$message({
                    message: res.message,
                    type: "error"
                });
            });
    })
})

/**
 * @description 对页面的按钮进行分类 放入table和头部
 */
export const getBtnPermission =(function (btnList) {
    let tmpTableBtnList=[],tmpTableBtnList2=[],curBtnList=btnList;
    curBtnList.map(item =>{
        if(item.value=='add' || item.value=='importExcel' || item.value=='exportExcel' || item.value=='initYuZhi' || item.value=='baojingshezhi' ){
            tmpTableBtnList2.push(item)

        }else{
            tmpTableBtnList.push(item)  //修改 删除 编辑 换床 出院放一起
        }
    })
    return {headBtnList:tmpTableBtnList2,tableBtnList:tmpTableBtnList}
})

/**
 * @description 对页面的form表单提交方法封装
 */
export const baseSubmitForm =(function (that,cloneParams,apiParams) {
    that.$refs.dataForm.validate(valid => {
        if (valid) {
            if (cloneParams.id == "") {
                //新增
                that.$api[apiParams].create(cloneParams).then(res => {
                        that.findPage(null);
                        that.closeDialog()
                    })
            } else {
                that.$api[apiParams]
                    .update(cloneParams.id, cloneParams)
                    .then(res => {
                        that.findPage(null);
                        that.closeDialog()
                    })
            }
        } else {
            return false;
        }
    });
})

/**
 * @description 对页面的form表单内容重置
 */
export const initDataForm =(function (that) {
    if(!!that.cloneDataForm){
        that.dataForm=JSON.parse(JSON.stringify(that.cloneDataForm))   //把dataForm的值还原成第一次时的值
        that.dialogVisible = false;
        that.dataForm.id=''
        if(that.stepIndex){
            that.stepIndex=0
        }
    }else{
        that.cloneDataForm=JSON.parse(JSON.stringify(that.dataForm))   //第一次拷贝复制dataForm的值
    }

})

export const formateDate =  (function (date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
      }
    }
    return fmt
  }
)
  // 左边补0函数
  function padLeftZero (str) {
    return ('00' + str).substr(str.length)
  }
 